import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import Detail from './Detail';
import Grid from '../grid/GridWrapper';
import Tabs from '../TabsWrapper';
import Tab from '../Tab';
import { parseValue, getValueByPath, getPrimaryField, processBefore, processAfter, processEnumsAfter, isDateType } from '../utils/helper';
import { showMsg } from '../utils/logger';
import withMeta from '../utils/withMeta';
import flags from '../utils/flags';
import eventEmitter from '../utils/eventEmitter';
import Frm from "./Frm";
import metaAkcFactory from "./akcFactory";
import metaReducer from "./reducer";

import { connect } from 'react-redux';
import withRouter from '../utils/withRouter';

const DEFAULT_STATE = {
  isLoading: false,
  data: [],
  tabs: [],
  oldData: null,
  total: 0,
  isDetailLoading: false,
  isDetailDisabled: false,
  detailData: {},
  modified: false,
  selected: [],
  printItems: [],
  cellRender: null,
  rowProps: null,
  subGridDetailRow: null
};

class GridComponent extends React.Component {
  detailData;

  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      detailSchema: [],
      gridSchema: [],
      ui: null,
      agrs: null,
      pages: null,
      allColumns: true,
      akc: {
        hidden: 0,
        disabled: 0,
        akc: []
      },
      frms: [],
      selectedFrm: null,
      frmFixedFilter: {},
      frmValue: null,
      frmId: null,
      primaryField: props.primaryField,
      level: props.level || 0,
      enterEdit: true,
      [props.primaryField]: DEFAULT_STATE,
      db: props.db,
      deleteText: null,
      cancelText: null,
      tlac: null,
      showAbort: false
    }
  }

  setStateAsync = (fnc) => {
    return new Promise((resolve) => {
      this.setState(fnc, resolve);
    });
  }

  getReducerState = async (action, data, state) => {
    const { reducer } = this.props;
    const reducerState = await metaReducer(action, { ...data, obj: this.getObj() }, { ...state, primaryField: this.props.primaryField }, this.state, reducer);
    return reducerState;
  }

  processReducer = async (action, data) => {
    const state = await this.getReducerState(action, data, _.cloneDeep(this.state));
    await this.setStateAsync(s => (state));
  }

  handleChange = (filter, sort, page) => {
    this.filter = filter;
    this.sort = sort;
    this.page = page;
    this.setState({ [this.props.primaryField]: { ...this.state[this.props.primaryField], oldData: null } });
  }

  copyFilter = (filter) => {
    return {
      ...filter,
      filters: filter.filters.map(x => {
        if (x.value instanceof Date) {
          return {
            ...x,
            value: new Date(x.value.getTime())
          }
        }

        return x;
      })
    };
  }

  processEnums = (res, primaryField) => {
    if (this.props.primaryField === primaryField) {
      res.Data.Items.forEach(x => {
        this.gridEnumColumns.forEach(column => {
          const value = this.state[column.dataField]?.find(el => el[column.primaryField] === _.get(x, column.field) || el[column.primaryField] === _.get(x, column.field + "." + column.primaryField)) || null
          _.set(x, column.field, value);
        })
      })
    }
    else {
      this.state.detailSchema.forEach((x) => {
        if (x.primaryField === primaryField && this.props.primaryField !== primaryField) {
          let enumColumns = x.schema.filter(x => x.type === 'enum' || x.type === 'buttongroup' || x.type === 'radio');
          let state = {};
          enumColumns.map((x) => {
            let data = (!x.required && x.EnumData) ? [{ [getPrimaryField(x.primaryField)]: null, [x.textField]: "" }, ...x.EnumData] : x.EnumData;
            state = { ...state, [`listGrid${x.field}`]: data, [`list${x.field}`]: { data: data } };
            return x;
          });
          this.setState(state, () => {
            res.Data.Items.forEach(x => {
              enumColumns.forEach(column => {
                const dataField = `listGrid${column.field}`;
                if (typeof (x[column.field]) !== 'object') {
                  const value = this.state[dataField].find(el => el[column.primaryField] === _.get(x, column.field) || el[column.primaryField] === _.get(x, column.field + "." + column.primaryField)) || null
                  _.set(x, column.field, value);
                }
              })
            })
          })
        }
      })
    }
  }

  processEnumsDetail = (data) => {
    this.detailEnumColumns.forEach(column => {
      if (typeof (data[column.field]) !== 'object') {
        const value = this.state[column.dataField].data.find(el => el[column.primaryField] === _.get(data, column.field) || el[column.primaryField] === _.get(data, column.field + "." + column.primaryField)) || null
        _.set(data, column.field, value);
      }
    })
  }

  getList = async (filter, sort, page, primaryField) => {
    const { filterFactory } = this.props;

    const f = filterFactory ? filterFactory(primaryField, this.copyFilter(filter)) : this.copyFilter(filter);
    try {
      await this.setStateAsync(s => ({ [primaryField]: { ...this.state[primaryField], isLoading: true, data: [], total: 0 }, showAbort: true }));
      const res = await this.props.meta.getList(primaryField, f, sort, page, this.props.db);
      if (this.gridDateColumns.length > 0) {
        res.Data.Items.map(x => {
          x = processAfter(this.gridDateColumns, x);
          return x;
        })
      }

      this.processEnums(res, primaryField);

      const state = { [primaryField]: { ...this.state[primaryField], isLoading: false, data: res.Data.Items, total: res.Data.TotalRecords }, showAbort: false };
      const reducerState = await this.getReducerState('GET_LIST', {}, state);
      await this.setStateAsync(s => (reducerState));
      this.props.getListSuccess(res);
    }
    catch (error) {
      this.setState(state => ({ [primaryField]: { ...state[primaryField], isLoading: false, data: [], total: 0 }, showAbort: false }));
      this.props.getListFailure(error);
    }
    this.getTotal(f, primaryField);
  }

  getTotal = async (filter, primaryField) => {
    try {
      const res = await this.props.meta.getTotal(primaryField, filter, this.props.db);
      if (res?.Data?.TotalRecords) {
        const state = { [primaryField]: { ...this.state[primaryField], total: res.Data.TotalRecords } };
        const reducerState = await this.getReducerState('GET_TOTAL', {}, state);
        await this.setStateAsync(s => (reducerState));
      }
    }
    catch (error) {
      this.props.getListFailure(error);
    }
  }

  get = async (val) => {
    try {
      await this.setStateAsync(s => ({ [this.props.primaryField]: { ...this.state[this.props.primaryField], isDetailLoading: true } }));

      let res = this.state.allColumns ? (typeof (val) == 'object' ? val : { Data: this.state[this.props.primaryField].data.find(x => x[getPrimaryField(this.props.primaryField)] === val) }) : await this.props.meta.get(this.props.primaryField, val, this.props.db);
      if (!res?.Data) {
        res = { Data: this.detailData }
      }
      else {
        res.Data = processAfter(this.state.detailSchema, res.Data || {});
      }
      this.processEnumsDetail(res.Data);

      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, detailData: res.Data } };
      let reducerState = await this.getReducerState('GET', {}, state);
      if (res.Data[getPrimaryField(this.props.primaryField)] === null) {
        reducerState = await this.getReducerState('GET_CREATE', {}, reducerState);
      }
      await this.setStateAsync(s => (reducerState));
      await this.props.getDetailSuccess(res);
    }
    catch (error) {
      this.setState(state => ({ [this.props.primaryField]: { ...state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, listDetail: {} } }));
      this.props.getDetailFailure(error);
    }
  }

  _get = async (primaryField, id) => {
    try {
      let res = await this.props.meta.get(primaryField, id, this.props.db);
      const schema = await this.props.meta.getSchema(primaryField, this.props.db);
      if (res?.Data && res.Data !== null) {
        res.Data = processAfter(schema?.Detail, res.Data);
        res.Data = processEnumsAfter(schema?.Detail, res.Data);
        return res.Data;
      }
      else {
        return null;
      }
    }
    catch (error) {
      return null;
    }
  }

  create = async (d) => {
    const detailData = processBefore(this.state.detailSchema, d);
    detailData[getPrimaryField(this.props.primaryField)] = 0;

    try {
      this.setState(state => ({ [this.props.primaryField]: { ...state[this.props.primaryField], isDetailLoading: true, isDetailDisabled: true } }));
      const res = await this.props.meta.create(this.props.primaryField, detailData, this.props.db);
      res.Data = processAfter(this.state.detailSchema, res.Data);
      this.processEnumsDetail(res.Data);

      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, detailData: res.Data } };
      const reducerState = await this.getReducerState('CREATE', { data: res.Data }, state);
      await this.setStateAsync(s => (reducerState));
      this.props.createSuccess(res);
      const id = res.Data[getPrimaryField(this.props.primaryField)];
      await this.getListAndSelect(id);
      return id;
    }
    catch (error) {
      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, listDetail: {} } };
      await this.setStateAsync(s => (state));
      this.props.createFailure(error);
    }
  }

  update = async (id, d) => {
    if (id === 0) {
      return await this.create(d);
    }

    const detailData = processBefore(this.state.detailSchema, d);
    const primaryField = getPrimaryField(this.props.primaryField);

    try {
      this.setState(state => ({ [this.props.primaryField]: { ...state[this.props.primaryField], isDetailLoading: true, isDetailDisabled: true } }));
      const res = await this.props.meta.update(this.props.primaryField, id, detailData, this.props.db);
      res.Data = processAfter(this.state.detailSchema, res.Data);
      this.processEnumsDetail(res.Data);

      const data = this.state[this.props.primaryField].data.map(item => item[primaryField] === res.Data[primaryField] ? { ...item, ...res.Data } : item);

      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, detailData: res.Data, data: data, oldData: null } };
      const reducerState = await this.getReducerState('UPDATE', { data: res.Data }, state);
      await this.setStateAsync(s => (reducerState));
      this.props.updateSuccess(res);
      await this.getListAndSelect(id);
    }
    catch (error) {
      const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false, isDetailLoading: false, isDetailDisabled: false, listDetail: {} } };
      await this.setStateAsync(s => (state));
      this.props.updateFailure(error);
    }
  }

  delete = async (id) => {
    try {
      const res = await this.props.meta.delete(this.props.primaryField, id, this.props.db);
      this.props.deleteSuccess(res);
    }
    catch (error) {
      this.props.deleteFailure(error);
    }
  }

  getListAndSelect = async (id) => {
    await this.getList(this.filter, this.sort, this.page, this.props.primaryField);
    const primaryField = getPrimaryField(this.props.primaryField);
    const selected = this.state[this.props.primaryField].data.filter(x => id === x[primaryField]);
    if (!_.isEqual(selected, this.state[this.props.primaryField].selected)) {
      await this.handleSelect(selected);
    }
  }

  changeField = async (name, value) => {
    const { primaryField } = this.props;
    const detailData = { ...this.state[primaryField].detailData };
    const oldValue = _.get(detailData, name);
    _.set(detailData, name, value);
    const state = { [primaryField]: { ...this.state[primaryField], modified: true, detailData: detailData } };
    let reducerState = await this.getReducerState('CHANGE', { field: name, value: value, oldValue: oldValue }, state);
    if (getPrimaryField(this.props.primaryField) === name && value === 0 && oldValue !== 0) {
      reducerState = await this.getReducerState('CHANGE_COPY', {}, reducerState);
    }
    await this.setStateAsync(s => (reducerState));
  }

  discardChanges = async () => {
    const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], modified: false } };
    const reducerState = await this.getReducerState('DISCARD_CHANGES', {}, state);
    await this.setStateAsync(s => (reducerState));
  }

  blur = async (field, value) => {
    const reducerState = await this.getReducerState('BLUR', { field, value }, {});
    await this.setStateAsync(s => (reducerState));
  }

  handleItemChange = async (event, data) => {
    const { primaryField } = this.props;
    const state = {
      [primaryField]: {
        ...this.state[primaryField],
        data: data.map(x => x[getPrimaryField(primaryField)] === event.dataItem[getPrimaryField(primaryField)] ? { ...x, [event.field]: event.value, hasChanged: event.hasChanged } : x),
        oldData: this.ref.current.ref.current.state.oldData
      }
    };
    const dataItem = state[primaryField].data.find(x => x[getPrimaryField(primaryField)] === event.dataItem[getPrimaryField(primaryField)]);
    const reducerState = await this.getReducerState('ITEM_CHANGE', { field: event.field, value: event.value, dataItem: dataItem }, state);
    await this.setStateAsync(s => (reducerState));
    return reducerState[primaryField].data;
  }

  getPickerValue = async (primaryField, defaultValue) => {
    const id = parseValue(defaultValue, 'container');
    if (id === parseInt(id, 10)) {
      const res = await this.props.meta.get(primaryField, id, this.props.db);
      if (res && res.Data) {
        this.setState({ isDetailLoading: false });
        return res.Data;
      }
    }
    return null;
  }

  getValue = async (x) => {
    const { defaultValue } = x;

    switch (x.type) {
      case "enum":
      case "buttongroup":
      case "radio":
        const id = parseValue(defaultValue, 'enum');
        return defaultValue ? this.state[x.dataField].data?.find(e => e[getPrimaryField(x.primaryField)] === id) : null;
      case 'container':
        return defaultValue ? await this.getPickerValue(x.primaryField, defaultValue) : null;
      case 'boolean':
        return parseValue(defaultValue) || false;
      default:
        return parseValue(defaultValue, x.type);
    }
  }

  onGetSchema = async (schema) => {
    const emptySort = [];
    const emptyPage = { skip: 0, take: 1000 };
    const emptyFilter = { filters: [] };
    this.gridDateColumns = schema.Grid.filter(x => isDateType(x.filter) || x.type === "daterange" || x.type === "21");
    this.gridEnumColumns = schema.Grid.filter(x => x.type === 'enum' || x.type === 'buttongroup' || x.type === 'radio');
    this.detailEnumColumns = schema.Detail.filter(x => x.type === 'enum' || x.type === 'buttongroup' || x.type === 'radio');

    this.gridEnumColumns.forEach((x) => {
      x.primaryField = getPrimaryField(x.primaryField);
      x.dataField = `listGrid${x.field}`;
      x.data = `list${x.field}`;
    });
    this.detailEnumColumns.forEach((x) => {
      x.primaryField = getPrimaryField(x.primaryField);
      x.dataField = `list${x.field}`;
    });

    let state = {};
    for (const x of this.gridEnumColumns) {
      if (x.primaryField && x.primaryField !== "I_HOD" && !x.EnumData) {
        const res = await this.props.meta.getList(x.primaryField, emptyFilter, emptySort, emptyPage, this.props.db);
        x.EnumData = res.Data ? res.Data.Items : [];
      }
      let data = (!x.required && x.EnumData) ? [{ [getPrimaryField(x.primaryField)]: null, [x.textField]: "" }, ...x.EnumData] : x.EnumData;
      state = { ...state, [`listGrid${x.field}`]: data, [`list${x.field}`]: { data: data } };
    }
    await this.setStateAsync(s => (state));

    this.detailData = {};
    for (const x of schema.Detail) {
      const defaultValue = await this.getValue(x);
      _.set(this.detailData, x.field, defaultValue);
    }
    const ui = schema?.Args?.ui;
    const args = _.omit(schema?.Args, "ui");

    if (this.props.frmValue) {
      schema.Detail.forEach(x => {
        if (this.props.frmValue[x.field]) {
          x.disabled = true;
        }
      })
      this.detailData = { ...this.detailData, ...this.props.frmValue }
    }

    let tabs = []
    try {
      tabs = await this.props.meta.getTabs(this.props.primaryField, this.props.db);
    }
    catch (err) {
      tabs = []
    }

    const tlac = await this.props.meta.getTlac(this.props.primaryField);
    const akc = await this.props.meta.getAkc(this.props.frmId || schema.Id, this.props.frmId !== undefined, this.props.db);
    state = {
      primaryField: this.props.primaryField,
      detailSchema: schema.Detail, gridSchema: schema.Grid, ui, args, akc, tlac, frms: schema.Frms, pages: schema.Pages, allColumns: schema.AllColumns,
      [this.props.primaryField]: { ...DEFAULT_STATE, detailData: this.detailData, printItems: [], tabs: tabs }
    };
    const reducerState = await this.getReducerState('GET_SCHEMA', {}, state);
    this.setState(reducerState);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.primaryField !== this.props.primaryField) {
      eventEmitter.changeTab(this.props.primaryField, 0);
      if (!this.state[this.props.primaryField]) {
        this.setState({ [this.props.primaryField]: DEFAULT_STATE });
      }
    }
    if (prevProps.db !== this.props.db) {
      this.setState({ db: this.props.db });
    }
  }

  getJoinValue = (x, selected) => {
    if (!_.isNil(x.Value)) {
      return parseValue(x.Value, x.Type);
    }
    const value = ["isnull", "isnotnull"].includes(x.Operator) ? null : _.uniq(getValueByPath(selected, x.ParentField)).join();

    if (value === "") {
      return x.Operator === "eq-ifexists" ? null : "-1";
    }
    return value;
  }

  handleChangeFrm = (name, data) => {
    const selected = name === "formDataTable" ? [this.state[this.props.primaryField].detailData] : this.state[this.props.primaryField].selected;
    let filters = [], frmValue = null, frmId = null;
    if (selected?.[0] && data?.Joins) {
      frmValue = {};
      frmId = data.Id;
      data.Joins.forEach(x => {
        const v = selected[0];
        if (x.Value !== null) {
          frmValue[x.Field.split('.')[0]] = parseValue(x.Value, x.Type);
        } else {
          let value;
          if (x.ParentField && x.ParentField.includes('.')) {
            if (x.Field && x.Field.includes('.')) {
              value = v[x.ParentField.split('.')[0]]
            } else {
              value = _.get(v, x.ParentField, null)
            }
          } else if (x.Field && x.Field.includes('.')) {
            value = v;
          } else {
            value = v[x.ParentField]
          }
          frmValue[x.Field.split('.')[0]] = value;
        }
        filters.push({
          field: x.Field,
          parentField: x.ParentField,
          value: this.getJoinValue(x, selected),
          operator: x.Operator ? x.Operator.split('-')[0] : 'in'
        })
      })
    }

    this.setState({ frmValue, selectedFrm: data, frmFixedFilter: { filters }, frmId });
  }

  handleSelect = async (selected) => {
    const state = { [this.props.primaryField]: { ...this.state[this.props.primaryField], selected } };
    const reducerState = await this.getReducerState('SELECT', {}, state);
    await this.setStateAsync(s => (reducerState));
  }

  handlePrint = async (index, name, tlac) => {
    await this.processReducer('PRINT', { name, value: true, tlac });
  }

  handleCancel = async (id) => {
    const primaryField = getPrimaryField(this.props.primaryField);
    const data = this.state.allColumns ? this.state[this.props.primaryField].selected.find(x => x[primaryField] === id) : this.state[this.props.primaryField].detailData;
    await this.update(id, { ...data, ZRUS: true, Zrus: true });
  }

  getObj = (akc, isDetailAkc = false) => {
    return {
      processReducer: this.processReducer,
      get: this._get,
      getList: this.getList,
      filter: this.filter,
      sort: this.sort,
      page: this.page,
      ref: this.ref,
      self: this,
      componentFactory: this.props.componentFactory,
      akc: akc,
      isDetailAkc: isDetailAkc,
    }
  }

  getSelectActions = () => {
    const { selectAkcFactory, showMsg } = this.props;
    if (selectAkcFactory) {
      return selectAkcFactory(this.state, showMsg, this.handleSelect);
    }
    else return undefined;
  }

  getActions = () => {
    const { akcFactory } = this.props;
    return this.state.akc.akc.filter(a => [1, 3].includes(a.Umiest)).map(a =>
      <React.Fragment key={'akc-' + a.IAkc}>{metaAkcFactory(a.IAkc, this.state, this.props.showMsg, this.getObj(a), akcFactory)}</React.Fragment>
    )
  }

  getDetailActions = () => {
    const { akcFactory } = this.props;
    return this.state.akc.akc.filter(a => [2, 3].includes(a.Umiest)).map(a =>
      <React.Fragment key={'akc-' + a.IAkc}>{metaAkcFactory(a.IAkc, this.state, this.props.showMsg, this.getObj(a, true), akcFactory)}</React.Fragment>
    );
  }

  subGridDetailRow = (props) => {
    const { subGridDetailRow } = this.state[this.props.primaryField] || DEFAULT_STATE;
    return subGridDetailRow({ ...props, obj: this.getObj() });
  }

  handleAdd = async () => {
    const { primaryField } = this.props;
    const item = { ...this.detailData, [getPrimaryField(primaryField)]: 0, inEdit: true, hasChanged: true };

    const state = { [this.props.primaryField]: { ...this.state[primaryField], isLoading: false, data: [item, ...this.state[primaryField].data] } };
    const reducerState = await this.getReducerState('ADD', {}, state);
    await this.setStateAsync(s => (reducerState));

    await this.handleSelect([item]);
    //Po pridaní autofocus, aby sa dalo v bunke rovno písať
    const dummy = document.querySelector('tr.k-master-row.k-selected.k-grid-edit-row input');
    if (dummy && dummy.type === "text") {
      dummy.focus();
    }
  }

  handleCopy = async () => {
    const { primaryField } = this.props;
    const { selected } = this.state[primaryField];
    const item = { ...selected[0], [getPrimaryField(primaryField)]: 0, inEdit: true, hasChanged: true };

    const state = { [primaryField]: { ...this.state[primaryField], isLoading: false, data: [item, ...this.state[primaryField].data] } };
    const reducerState = await this.getReducerState('ADD', {}, state);
    await this.setStateAsync(s => (reducerState));

    await this.handleSelect([item]);
    //Po pridaní autofocus, aby sa dalo v bunke rovno písať
    const dummy = document.querySelector('tr.k-master-row.k-selected.k-grid-edit-row input');
    if (dummy && dummy.type === "text") {
      dummy.focus();
    }
  }

  handleAbortChanges = async (dataItem) => {
    const { primaryField } = this.props;
    const oldData = _.cloneDeep(this.ref.current.ref.current.state.oldData);
    const originalItem = oldData.find(item => item[primaryField] === dataItem[primaryField]);
    const data = this.state[primaryField].data.map(item => item[getPrimaryField(primaryField)] === originalItem[getPrimaryField(primaryField)] ? originalItem : item);
    const state = { [primaryField]: { ...this.state[primaryField], isLoading: false, data: data } };
    const reducerState = await this.getReducerState('ABORT_CHANGES', {}, state);
    await this.setStateAsync(s => (reducerState));
  }

  handleAbortChangesAll = async () => {
    const { primaryField } = this.props;
    const oldData = _.cloneDeep(this.ref.current.ref.current.state.oldData);
    const data = oldData.map(item => { return _.omit(item, ['inEdit', 'hasChanged']) }).filter(x => x[getPrimaryField(primaryField)] !== 0);
    const state = { [primaryField]: { ...this.state[primaryField], isLoading: false, data: data } };
    const reducerState = await this.getReducerState('ABORT_CHANGES_ALL', {}, state);
    await this.setStateAsync(s => (reducerState));

    await this.handleSelect([]);
  }

  handleEnterEdit = async (dataItem, field) => {
    const reducerState = await this.getReducerState('ENTER_EDIT', { dataItem, field }, { enterEdit: this.state.enterEdit });
    return reducerState.enterEdit;
  }

  handleExitEdit = async (dataItem, field, data) => {
    const { primaryField } = this.props;
    const state = { [primaryField]: { ...this.state[primaryField], oldData: null } };
    const reducerState = await this.getReducerState('EXIT_EDIT', { dataItem, field, data }, state);
    await this.setStateAsync(s => (reducerState));
  }

  render() {
    const { isLoading, selected, data, total, tabs, oldData, detailData, isDetailLoading, modified, rowProps, isDetailDisabled, cellRender, printItems, subGridDetailRow }
      = (this.state.primaryField !== this.props.primaryField ? DEFAULT_STATE : (this.state[this.props.primaryField] || DEFAULT_STATE));
    const { detailSchema, deleteText, cancelText } = this.state;
    const editDisabled = Boolean(flags.DETAIL & this.state.akc.hidden) && (flags.EDIT & this.state.akc.hidden) > 0;
    const currentEl = this.props.currentElFactory ? this.props.currentElFactory(this.state, this.props.showMsg, this.getObj(null)) : null;

    return (
      <>
        <Tabs name={this.props.primaryField}>
          {[<Tab title="Zoznam" key="grid">
            <Grid
              ref={this.ref}
              className={this.props.primaryField}
              total={total}
              toolbarActions={this.getActions()}
              data={data}
              oldData={oldData}
              isLoading={isLoading}
              onChange={this.handleChange}
              onPrint={this.handlePrint}
              schema={this.state.gridSchema}
              primaryField={this.props.primaryField}
              onChangeField={this.changeField}
              onItemChange={this.handleItemChange}
              onGet={this.get}
              onGetList={() => this.getList(this.filter, this.sort, this.page, this.props.primaryField)}
              onCreate={this.create}
              onDelete={this.delete}
              onUpdate={this.update}
              onCancel={this.handleCancel}
              onAdd={editDisabled ? this.handleAdd : null}
              onCopy={editDisabled ? this.handleCopy : null}
              modified={modified}
              allColumns={this.state.allColumns}
              onGetSchema={this.onGetSchema}
              disabled={this.props.disabled || this.state.akc.disabled}
              hidden={this.props.hidden || this.state.akc.hidden}
              getList={this.getList}
              parentProps={{ ...this.state, getList: this.getList, updateData: this.update, handleChangeFrm: this.handleChangeFrm }}
              onSelect={this.handleSelect}
              onSubmit={() => this.getList(this.filter, this.sort, this.page, this.props.primaryField)}
              fixedFilter={this.props.fixedFilter || null}
              initFilter={this.props.initFilter || null}
              onAbortChangesAll={this.handleAbortChangesAll}
              onAbortChanges={this.handleAbortChanges}
              enterEdit={this.handleEnterEdit}
              exitEdit={this.handleExitEdit}
              withMeta
              editable
              editableCell={!((this.state.akc.hidden || this.props.hidden) & flags.EDITCELL)}
              cellSelect={!((this.state.akc.hidden || this.props.hidden) & flags.EDITCELL)}
              showToolbarButtons={!((this.state.akc.hidden || this.props.hidden) & flags.EDITCELL)}
              detail={subGridDetailRow ? this.subGridDetailRow : null}
              cellRender={cellRender}
              rowProps={rowProps}
              printItems={printItems}
              printable
              multiple={!(this.props.disabled & flags.ONLY_SELECT)}
              sortDialog
              userFilter
              reset
              deleteAll
              db={this.props.db}
              reducer={this.props.reducer}
              componentFactory={this.props.componentFactory}
              actions={this.getSelectActions()}
              selected={selected}
              deleteText={deleteText}
              cancelText={cancelText}
              tlac={this.state.tlac}
              showAbort={this.state.showAbort}
            />
          </Tab>,
          <Tab title="Detail" key="detail" hideStandardInactive>
            <Detail
              onSubmit={() => { }}
              detailData={detailData}
              onChangeField={this.changeField}
              allData={data}
              isDetailLoading={isDetailLoading}
              onGet={this.get}
              onCreate={this.create}
              onUpdate={this.update}
              onDiscard={this.discardChanges}
              onBlur={this.blur}
              getList={this.getList}
              primaryField={this.props.primaryField}
              schema={detailSchema}
              disabled={!!(flags.DETAIL & this.state.akc.disabled) || isDetailDisabled}
              akcDisabled={this.state.akc?.disabled}
              akcHidden={this.state.akc?.hidden}
              isPicker={Boolean(flags.DETAIL & this.props.hidden)}
              modified={modified}
              ui={this.state.ui}
              args={this.state.args}
              pages={this.state.pages}
              componentFactory={this.props.componentFactory}
              currentEl={currentEl}
              toolbarActions={this.getDetailActions()}
              akcFactory={this.props.akcFactory}
              handleChangeFrm={this.handleChangeFrm}
              reducer={this.props.reducer}
              {...this.state}
            />
          </Tab>,
          ...tabs.map((tab, i) => {
            return (
              <Tab title={tab.name} key={`${tab.name}-${i}`} disabled={tab.iZobraz === 2}>
                {this.props.getComponent(tab.iKomponent, this.state)}
              </Tab>
            );
          })
          ]}
        </Tabs>
        <Frm
          onClose={() => this.handleChangeFrm("frm", null)}
          selectedFrm={this.state.selectedFrm}
          fixedFilter={this.state.frmFixedFilter}
          componentFactory={this.props.componentFactory}
          frmValue={this.state.frmValue}
          frmId={this.state.frmId}
          level={this.state.level}
          reducer={this.props.reducer}
          filterFactory={this.props.filterFactory}
          akcFactory={this.props.akcFactory}
          currentElFactory={this.props.currentElFactory}
          db={this.props.db}
          parent={{ props: this.props, state: this.state }}
          modal
        />
      </>
    );
  }
}

GridComponent.propTypes = {
  primaryField: PropTypes.string.isRequired,
  frmValue: PropTypes.object,
  frmId: PropTypes.number,
  level: PropTypes.number,
  componentFactory: PropTypes.func,
  reducer: PropTypes.func,
  filterFactory: PropTypes.func,
  akcFactory: PropTypes.func,
  currentElFactory: PropTypes.func,
  initFilter: PropTypes.object,
  db: PropTypes.string,
  parentProps: PropTypes.object,
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  getListSuccess: res => dispatch({ type: 'GET_LIST_SUCCESS', res }),
  getListFailure: error => dispatch({ type: 'GET_LIST_FAILURE', error }),
  getDetailSuccess: res => dispatch({ type: 'GET_SUCCESS', res }),
  getDetailFailure: error => dispatch({ type: 'GET_FAILURE', error }),
  createSuccess: res => dispatch({ type: 'CREATE_SUCCESS', res }),
  createFailure: error => dispatch({ type: 'CREATE_FAILURE', error }),
  updateSuccess: res => dispatch({ type: 'UPDATE_SUCCESS', res }),
  updateFailure: error => dispatch({ type: 'UPDATE_FAILURE', error }),
  deleteSuccess: res => dispatch({ type: 'DELETE_SUCCESS', res }),
  deleteFailure: error => dispatch({ type: 'DELETE_FAILURE', error }),
  showMsg: (msg, msgType = 'ok', isDialog = false, title) => dispatch(showMsg(msg, msgType, isDialog, title))
})

export default withMeta(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(GridComponent)));